import { render, staticRenderFns } from "./SignatureViewPopup.view.vue?vue&type=template&id=e9bcafb8&"
import script from "./SignatureViewPopup.view.vue?vue&type=script&lang=js&"
export * from "./SignatureViewPopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9bcafb8')) {
      api.createRecord('e9bcafb8', component.options)
    } else {
      api.reload('e9bcafb8', component.options)
    }
    module.hot.accept("./SignatureViewPopup.view.vue?vue&type=template&id=e9bcafb8&", function () {
      api.rerender('e9bcafb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/signature/SignatureViewPopup.view.vue"
export default component.exports